import React, { Component, Fragment } from "react"
import PropTypes from "prop-types"
import { observer } from "mobx-react"
import { Table } from "semantic-ui-react"
import _ from "lodash"
import ProductRowDefault from "components/Product/ProductRowDefault"
import Responsive                                                from "react-responsive"
import { read } from "store/storages/cookieStorage"
import shop from "shop/shop"

@observer
export default class ProductTable extends Component {
  static propTypes = {
    list    : PropTypes.object,
    cart    : PropTypes.object,
    onChange: PropTypes.func,
    products: PropTypes.array,
  }
  
  render() {
    let { list, cart, products, onChange, readOnly, success, accountPage, rahmenauftrag } = this.props
    let ProductRow = this.props.row || ProductRowDefault
    let positions = list || products
    if ( list ) positions = list.products
    let rows = _.map( positions, ( product, index ) => {
      return (
        <ProductRow success={success} rahmenauftrag={rahmenauftrag} accountPage={accountPage} readOnly={readOnly} key={index} index={index} onChange={onChange} list={list} cart={cart} product={product}/>
      )
    } )
    console.log("products", products) 
    return (
            <Fragment>
            <Responsive maxWidth={shop.config.plugin.onePageCheckout ? 1299 : 899}>
              <table className="mobileRespTable" >
                <colgroup>
                  <col width="10%"/>
                  <col width="90%"/>
                  </colgroup>
                <tbody>
                {rows}
                </tbody>
              </table>
            </Responsive>
            <Responsive minWidth={shop.config.plugin.onePageCheckout ? 1300 : 900}>
            <Table className="productTableCheckout"  compact>
        <colgroup>
          <col width="35"/>
          <col width=""/>
          <col width="10%"/>
          <col width="15%"/>
          <col width="15%"/>
          <col width="12%"/>
          <col width="12%"/>
        </colgroup>
        <thead>
        <tr >
          <th>{translate( "producttable.article" )}</th>
          {<th>&nbsp;</th>}
          <th className="tr" style={{textAlign: "right"}}>{translate( "Preis/VE" )}</th>
          <th className="tc" style={{textAlign: "center"}}>{translate( "VE" )}</th>
          <th>{translate( "deliverable" )}</th>
          {/*<th>Preis/Stück</th>*/}
          {/*<th>{translate( "deliverable" )}</th>*/}
          {/*<th>{translate("Preis/Stück")}</th>*/}
          
          
          {/*<th>{translate( "total count" )}</th>*/}
          {readOnly ? <th style={{textAlign: "right"}}>{rahmenauftrag ? translate("Abgerufen") : translate( "Menge" )}</th> :
          <th>
            <div className="tr">
              {translate( "sum" )}
            </div>
          </th>}
          {/*<th>{translate( "VE" )}</th>*/}
          {/*<th style={{textAlign: "right"}}>{translate( "amount (VE)" )}</th>*/}
          {list && <th style={{ textAlign: "right" }}>{translate( "" )}</th>}
          {!readOnly ? <th style={{textAlign: "center"}}>{translate( "Menge (VE)" )}</th> :           
          <th>
            <div className="tr">
              {translate( "sum" )}
            </div>
          </th>}
          {!readOnly && <th>&nbsp;</th>}
        </tr>
        </thead>
        <tbody>
        {rows}
        </tbody>
      </Table>
            </Responsive>
          </Fragment>
    )
  }
}







// WEBPACK FOOTER //
// ./src/theme/demo2025/components/Product/ProductTable.js